
<script>
	import listBase from '@_system/components/base/list.vue'
	import editForm from './edit/index.vue'
	import dailyIndex from './daily/index.vue'
	export default {
		extends: listBase,
		name: 'bankaccountIndex',
		props: {

		},
		render(h) {
			this.$slots.plug = [ 
				<edit-form currentrow = {this.currentrow} onSuccess={this.editSuccess} ref = "bankaccountEdit" /> , 
				<daily-index ref = "dailyIndex" /> , 
			]
			return listBase.render.call(this, h)
		},
		data() {
			return {
				moduleName: 'bankaccount',
				windowName: 'bankaccount',
				windowType: 'modal',
				currentrow:{},
				pagerConfig: {
					autoHidden: false,
					border: true,
					size: 'mini',
					perfect: false,
					currentPage: 1,
					enabled:false,
					pageSize: 20,
					pageSizes: [10, 20, 50, 100, 200, 500],
				},
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {
			this.foreingKey.type = 'wln'
			this.foreingKey.mode = 'list'
			this.exportMethod = null
		},
		computed: {

		},

		methods: {
			export(){
				this.$refs[this.moduleName+'_list'].exportData({
					filename:"银行账户",
					type:"xlsx"
				}).catch(()=>{

				})
			},
			dailyreconciliation(){
				this.$refs.dailyIndex.modal_show()
			},
			beforeCreateGrid(formConfig,columns,gridOptions){
				gridOptions.exportConfig = {
					type: 'xlsx',
					types: ['xlsx', 'csv', 'html', 'xml', 'txt'],
					remote: false
				}
				columns.forEach((item)=>{
					if(item.field=='acc_code'){
						item.slots = {
							default: ({row}) => {	
								let str= []
								if(row.iscaizi==1){
									str.push(<el-tag size="mini" type="success" effect="dark" style="margin-right: 2px;">财</el-tag>)
								}
								str.push(<span>{row.acc_code}</span>)
								return str
							}
						}
					}
					if(item.field=='targetdepartment'){
						item.slots = {
							default: ({row}) => {	
								return row.targetdepartment
							}
						}
					}
				})
				
			},
			editformShow(row){
				this.currentrow = row
				this.$nextTick(()=>{
					this.$refs.bankaccountEdit.modal_show()
				})
				
			},
			editSuccess(){
				this.customreload()
			}
		},
		components: {
			editForm,
			dailyIndex
		}
	}
</script>
